import { Container, Tab, Tabs, Box } from "@mui/material";
import { useState } from "react";

import WorkstationMonitorTab from "~/features/serviceSupport/workstationsMonitor/WorkstationsMonitorTab";
import { useNavbar, ViewNameTranslation } from "~/hooks/useNavbar";

import { MicroAndonBoard } from "./MicroAndonBoard";
import WorkstationDashboard from "./WorkstationDashboard";

type Props = { viewTitle?: ViewNameTranslation };

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`demo-tabpanel-${index}`}
      aria-labelledby={`demo-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `demo-tab-${index}`,
    "aria-controls": `demo-tabpanel-${index}`
  };
}

export function DemoPage(props: Props) {
  const { viewTitle } = props;
  const [value, setValue] = useState(0);

  useNavbar({ viewTitle });

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Container
      maxWidth={false}
      sx={{
        pt: 5,
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box"
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="demo page tabs">
          <Tab label="Workstation Monitor" {...a11yProps(0)} />
          <Tab label="Dashboard" {...a11yProps(1)} />
          <Tab label="Micro Andon" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <WorkstationMonitorTab />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <WorkstationDashboard />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <MicroAndonBoard />
      </TabPanel>
    </Container>
  );
}
